module.exports = __webpack_public_path__ + "static/media/saversBellIcon.4646e90e.svg";